import axios from 'axios';

const emailValidation = async ({ eventId, email }) => {
  const config = {
    method: 'GET',
    url: `${process.env.REACT_APP_BASE_URL}/pay/events/${process.env.REACT_APP_EVENT_ID}/attendees/email/${email}`,
    headers: {
      'content-type': 'application/json',
    },
  };

  try {
    const { data } = await axios(config);
    if (data.message === 'AVAILABLE') {
      return { success: true, data };
    }
    return { success: false, data };
  } catch (error) {
    return { success: false, data: error.response.data };
  }
};

const documentValidation = async ({ eventId, document }) => {
  const config = {
    method: 'GET',
    url: `${process.env.REACT_APP_BASE_URL}/pay/events/${
      process.env.REACT_APP_EVENT_ID
    }/attendees/document/${document.replace(/\D/g, '')}`,
    headers: {
      'content-type': 'application/json',
    },
  };

  try {
    const { data } = await axios(config);
    if (data.message === 'AVAILABLE') {
      return { success: true, data };
    }
    return { success: false, data };
  } catch (error) {
    return { success: false, data: error.response.data };
  }
};

export { emailValidation, documentValidation };
